import weightdimension from './weightdimension/index.vue';
import baserate from './baserate/index.vue';
import freightcharges from './freightcharges/index.vue';
import insurancecharges from './insurancecharges/index.vue';
import accessorialcharges from './accessorialcharges/index.vue';
import minimumcharges from './minimumcharges/index.vue';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../../services/masterdata.service';
import CONSTANT from "./../../../../shared/constants/constant";
import {BasicSelect} from  'vue-search-select';
import CryptoJS from 'crypto-js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
//import otherinformation from './otherinformation/index.vue';

export default {
	name: 'Rate-Template',
	components: {
		//DatePicker,
		'first': weightdimension,
		'second': baserate,
		'third': freightcharges,
		'fourth': insurancecharges,
		'fifth': accessorialcharges,
		'sixth': minimumcharges,
		VueElementLoading,
		BasicSelect,
		Treeselect
	},
	props: ['selectedEditRowDataChild', 'callingFrom'],
	data() {
		return {
			userName:null,
			tempTabClick:null,
			isTabChange:false,
			selectedEditRowData: JSON.parse(JSON.stringify(this.selectedEditRowDataChild)),
			callingFromObj: this.callingFrom && JSON.parse(JSON.stringify(this.callingFrom)),
			rateTemplateName: '',
			ratebasis:null,
			rateTemplateId: null,
			isLoading: false,
			currentTab: 'First',
			freightwttype: null,
			componentKey: 0,
			disableRatebasisFlag : false,
			rateTemplateList :[{
					label:"",
					id:""
				}
			],
			selectedRateTemplate:{
				label:null,
				id:null
			},
			isMasterRate:false,
			alreadySelectedObject:{
				label:'',
				id:''
			},
			tabs: [{
					key: 'First',
					value: 'Weight/Box Definitions'
				},
				{
					key: 'Second',
					value: 'Base Rate'
				},
				{
					key: 'Sixth',
					value: 'Minimum Charges'
				},
				{
					key: 'Third',
					value: 'Freight Charges'
				},
				{
					key: 'Fourth',
					value: 'Insurance Charges'
				},
				{
					key: 'Fifth',
					value: 'Accessorial Charges'
				},
			],
			servicetype : null,
			showRateTemplate : true
		}
	},
	created: function() {

	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1;
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.email = userdetail.email;
		this.setRateTemplateId();
	},
	methods: {
		setRateTemplateId() {
			if (this.selectedEditRowData && this.selectedEditRowData.id) {
				this.disableRatebasisFlag = true;
				this.getRateTemplateDetails(this.selectedEditRowData.id)
				this.rateTemplateName = this.selectedEditRowData.ratetemplatename;
				this.ratebasis = this.selectedEditRowData.ratebasis;
				this.servicetype = this.selectedEditRowData.servicetype;
			}
			this.$nextTick(() => {
				if(this.callingFromObj && this.callingFromObj.name){
					this.disableRatebasisFlag = true;
				  this.getRateTemplateListing();
				}
			})
		},
		selectRateTemplate(data){
			this.selectedRateTemplate = data;
			this.getRateTemplateDetails(data.id)
			this.callingFromObj.ratetemplatemasterid = data.id;
			this.rateTemplateName = data.label;
			this.setTab("First", "changeTab")
		},
		async getRateTemplateListing(){
			try {
			  let payload = {
			  }
			  if (this.callingFromObj.servicetype) {
				payload.servicetype = this.callingFromObj.servicetype
			  }
			  this.isLoading = true;
			  let result = await MasterService.getRateTemplateMasterListDropdown(payload);

			  this.isLoading = false;
			  this.rateTemplateList = result.data.data.rows.map((el)=>{
				let isdisabled = false;
				if(el.status == 0){
					isdisabled=true
				}
				return {
					id:el.id,
					label:el.ratetemplatename,
					isDisabled:isdisabled
				  }
			  })
			  	this.setRateTemplateDropDown();
				if(this.callingFromObj.id){
					this.getContractMasterRateDetails(this.callingFromObj.id)
				}
			} catch(err){
			  this.isLoading = false;
			  console.log(err);
			}
		  },
		  setRateTemplateDropDown(){
			// if(this.callingFromObj.ratetemplatemasterid){
			// 	this.alreadySelectedObject = this.rateTemplateList.find(o => o.value == this.callingFromObj.ratetemplatemasterid);
			// 	this.selectedRateTemplate.text = this.alreadySelectedObject.text;
			// 	this.selectedRateTemplate.value = this.alreadySelectedObject.value;
			// }
			//else {
			// 	this.callingFromObj.ratetemplatemasterid = null;
				if(this.callingFromObj && this.callingFromObj.contractRateTemplateDetails && this.callingFromObj.contractRateTemplateDetails.ratetemplatemasterid){
					this.alreadySelectedObject = this.rateTemplateList.find(o => o.id == this.callingFromObj.contractRateTemplateDetails.ratetemplatemasterid);
					if (this.alreadySelectedObject) {
						this.selectedRateTemplate = this.alreadySelectedObject;
					}else{
						this.showRateTemplate = false;
						this.selectedRateTemplate.id = this.callingFromObj.contractRateTemplateDetails.ratetemplatemasterid
					}
				}
			//}
		  },
		  setTab(tab, type, key){
			let currentTabIndex = 0;
			this.tabs.forEach((el, index) => {
				if (el.key == tab) {
					currentTabIndex = index;
				}
			})
			this.componentKey = currentTabIndex;
			this.currentTab = this.tabs[this.componentKey].key;
			 if(type !=  "createAndGetId" && !key) {
				this.tempTabClick = null
			 }
		  },
		async emitRateTemplateObject(type, key) {
			if(type == "changeTab"){
				this.tempTabClick = key;
				this.$refs.childComponent.saveOnTabChange();
				return;
			}

			// let currentTabIndex = 0;

			if(this.tempTabClick == 0 || this.tempTabClick) {
				this.setTab(this.tempTabClick, type, key)
				// this.tabs.forEach((el, index) => {
				// 	if (el.key == this.tempTabClick) {
				// 		currentTabIndex = index;
				// 	}
				// })
				// this.componentKey = currentTabIndex;
				// this.currentTab = this.tabs[this.componentKey].key;
				// // this.currentTab = this.tempTabClick;
				//  console.log("***this.tempTabClick***",this.currentTab);
				//  if(type !=  "createAndGetId" && !key) {
				// 	this.tempTabClick = null
				//  }
			} else {
				this.setTab(this.currentTab, type, key)
				// this.tabs.forEach((el, index) => {
				// 	if (el.key == this.currentTab) {
				// 		currentTabIndex = index;
				// 	}
				// })
				// this.componentKey = currentTabIndex;
				// this.currentTab = this.tabs[this.componentKey].key;
			}

			if (this.selectedEditRowData && this.selectedEditRowData.id) {
			if(!this.callingFromObj || this.isMasterRate) {
				await this.getRateTemplateDetails(this.selectedEditRowData.id)

			} else if(this.callingFromObj && this.callingFromObj.name) {
				if(this.callingFromObj.id){
				await this.getContractMasterRateDetails(this.callingFromObj.id)
				}
			}
			// this.$nextTick(() => {
			// 		this.$refs.childComponent.setValues(this.selectedEditRowData);
			// 	})
			}
		},
		async getRateTemplateDetails(id) {
			try {
				this.isLoading = true;
				let payload = {
					ratetemplateid: id
				}
				let result = await MasterService.rateTemplateMasterDetails(payload);
				// if (!this.callingFrom) {
				// 	let result = await MasterService.rateTemplateMasterDetails(payload);
				// } else if (this.callingFrom && this.callingFrom.name == "contract-template") {
				// 	console.log("******contract template rate details*****");
				// }
				this.selectedEditRowData = result.data.data.rows[0];
				this.freightwttype = result.data.data.rows[0].freightwttype;
				this.ratebasis = result.data.data.rows[0].ratebasis;
				this.servicetype = result.data.data.rows[0].servicetype;
				this.selectedEditRowData.id = id;
				this.isMasterRate = true;
				this.$refs.childComponent.setValues(this.selectedEditRowData, this.isMasterRate,2);
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},


		async getContractMasterRateDetails(id) {
			try {
				this.isLoading = true;
				let payload = {
					ratetemplateid: id,
					contractservicesid : this.callingFromObj.contractservicesid
				}
				let result
				if(this.callingFromObj.name == CONSTANT.CONTRACT_TEMPLATE){
					result = await MasterService.contractMasterRateDetails(payload);
				} else if(this.callingFromObj.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
					result = await MasterService.clientContractMasterRateDetails(payload);
				}
				this.selectedEditRowData = result.data.data.rows[0];
				this.freightwttype = result.data.data.rows[0].freightwttype;
				this.selectedEditRowData.id = id;
				this.callingFromObj.ratetemplatemasterid = result.data.data.rows[0].ratetemplatemasterid || null;
				this.selectedEditRowData.contractserviceid = result.data.data.rows[0].contractserviceid
				this.ratebasis = result.data.data.rows[0].ratebasis
				this.servicetype = result.data.data.rows[0].servicetype
				// this.$refs.childComponent.setValues(this.selectedEditRowData);
				this.$nextTick(() => {
					this.isMasterRate = false;
					this.$refs.childComponent.setValues(this.selectedEditRowData, this.isMasterRate);
				})
				this.isLoading = false;
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},


		findCurrentTabAndGoNext() {

			let currentTabIndex = 0;
			this.tabs.forEach((el, index) => {
				if (el.key == this.currentTab) {
					currentTabIndex = index;
				}
			})
			this.componentKey = currentTabIndex + 1;
			this.currentTab = this.tabs[this.componentKey].key;
			this.emitRateTemplateObject();
		},
		submitRateTemplate(data, type) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.saveRateTemplate(data, type);
				}
			}).catch((err) => {
				console.log('errors exist', err)
			});
		},
		async saveRateTemplate(data, type) {
			try {

				data.ratetemplatename = this.rateTemplateName.trim();
				data.ratebasis = this.ratebasis
				data.servicetype = this.servicetype
				if(data.isTabChange){
					this.isTabChange = data.isTabChange;
					delete data.isTabChange;
				}

				//For Now Putting freightwttype: as 0 It will changes
				if (!data.freightwttype) {
					if (this.freightcharges) {
						data.freightwttype = this.freightcharges;
					} else {
						data.freightwttype = 1;
					}
				}
				if (this.selectedEditRowData && this.selectedEditRowData.id) {
					data.ratetemplateid = this.selectedEditRowData.id;
				}
				data.createdby = this.email
				data.lastmodifiedby = this.email
				this.isLoading = true;
				let result
				if(!this.callingFromObj){
					// result = await MasterService.saveRateTemplateMaster(data);
					this.saveDefaultRateTemplate(data, type)
				} else if(this.callingFromObj && this.callingFromObj.name) {
					this.saveContractMasterRate(data, type)
					// let result = await MasterService.saveRateTemplateMaster(data);
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async saveDefaultRateTemplate(data, type){
			let result = await MasterService.saveRateTemplateMaster(data);
			let rateRemplateid = data.ratetemplateid || result.data.data;

			if (this.selectedEditRowData) {
				this.selectedEditRowData.id = this.selectedEditRowData.id || rateRemplateid;
			} else {
				this.selectedEditRowData = {};
				this.selectedEditRowData.id = rateRemplateid;
			}
			this.isLoading = false;
			if (result.data.code == 200) {
				if (type == "createAndGetId") {
					if(!this.isTabChange){
						this.$alertify.success(result.data.message)
						// this.$alert(result.data.message, this.rateTemplateName, "success");
					}
					this.isTabChange = false;
					this.emitRateTemplateObject("createAndGetId");
					let submitObj = {
						id: data.ratetemplateid || result.data.data,
						name: data.ratetemplatename
					}
					this.$refs.childComponent.setValuesAfterId(submitObj);
					return;
				}
				if (type == 'saveAndNext') {
					if(!this.isTabChange){
						this.$alertify.success(result.data.message)
						// this.$alert(result.data.message, this.rateTemplateName, "success");
					}
					this.isTabChange = false;
					// this.findCurrentTabAndGoNext();
					this.setTabNavigationCondition();

				} else {
					this.$emit("goBackToParent");
					this.$alert(result.data.message, this.rateTemplateName, "success");
				}
			} else {
				this.$alert(result.data.message, this.rateTemplateName, "error");
			}
		},

		setTabNavigationCondition(){
			if(this.tempTabClick == 0 || this.tempTabClick) {
				this.emitRateTemplateObject();
			} else {
				this.findCurrentTabAndGoNext();
			}
		},

		async saveContractMasterRate(data, type){
			try {
			data.ratetemplateid = this.callingFromObj.id;
			data.contractid = this.callingFromObj.contractid;
			data.contractservicesid = this.callingFromObj.contractservicesid;
			data.ratetemplatemasterid = (this.selectedRateTemplate && this.selectedRateTemplate.id) || (this.callingFromObj.contractRateTemplateDetails && this.callingFromObj.contractRateTemplateDetails.ratetemplatemasterid) || 0;
			data.rateeffectivedatefrom = this.callingFrom.rateeffectivedatefrom
			data.rateeffectivedateto = this.callingFrom.rateeffectivedateto
			delete data.ratetemplatename
			let result
			if(this.callingFromObj.name == CONSTANT.CONTRACT_TEMPLATE) {
				result = await MasterService.saveContractMasterRate(data);
			} else if (this.callingFromObj.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE){
				result = await MasterService.saveClientContractMasterRate(data);
			}
			let rateRemplateid =  this.callingFromObj.id || result.data.data;
			if(!this.callingFromObj.id){
				this.callingFromObj.id = result.data.data;
			}

			if (this.selectedEditRowData) {
				this.selectedEditRowData.id = this.selectedEditRowData.id || rateRemplateid;
			} else {
				this.selectedEditRowData = {};
				this.selectedEditRowData.id = rateRemplateid;
			}
			this.isLoading = false;
			if (result.data.code == 200) {
				if (type == "createAndGetId") {
					if(!this.isTabChange){
						this.$alertify.success(result.data.message)
						// this.$alert(result.data.message, this.rateTemplateName, "success");
					}
					this.isTabChange = false;
					this.emitRateTemplateObject("createAndGetId");
					let submitObj = {
						id: data.ratetemplateid || result.data.data,
						name: data.ratetemplatename
					}
					this.$refs.childComponent.setValuesAfterId(submitObj);
					return;
				}
				if (type == 'saveAndNext') {
					if(!this.isTabChange){
						this.$alertify.success(result.data.message)
						//this.$alert(result.data.message, this.rateTemplateName, "success");
					}
					this.isTabChange = false;
					// this.findCurrentTabAndGoNext();
					this.setTabNavigationCondition();

				} else {
					this.$emit("goBackToParent");
					this.$alert(result.data.message, this.rateTemplateName, "success");
				}
			} else {
				this.$alert(result.data.message, null, "error");
			}
		  } catch(err){
			this.isLoading = false;
			console.log(err);
		}
		},
		showListing() {
			this.$emit("goBackToParent")
		},
		save(event) {
			this.submitRateTemplate(event);
		},
		saveAndNext(data) {
			this.submitRateTemplate(data, 'saveAndNext')
		},
		goToNextStepOrListing(action) {
			if (action == 'next') {
				if(this.tempTabClick == 0 || this.tempTabClick) {
					this.emitRateTemplateObject();
				} else {
					this.findCurrentTabAndGoNext();
				}
			} else {
				this.$emit("goBackToParent");
			}

		},
		createAndGetId(data) {
			this.submitRateTemplate(data, 'createAndGetId')
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/ratetemplate.component.js